import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from "react-i18next";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, IconButton, Typography } from '@mui/material';
import { Close, Cancel, CheckCircle } from '@mui/icons-material';
import { Transition } from "./ControlUtils"

  
const Dialog4Confirm = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const returnValue = React.useRef(null);

    const [messageObject, setMessageObject] = useState({
        Title: "",
        Content: "",
        IsOpen: false,
    });
    
    useImperativeHandle(ref, () => ({
        // 부모 컴포넌트에서 사용할 함수를 선언
        showMessageBox,
        showMessageBoxEmptyResult,
        setMessageObject
    }));

    const showMessageBox = (title, content, returnMethod) => {
        setMessageObject({
            Title: title,
            Content: content,
            IsOpen: true,
        });
        returnValue.current = returnMethod;
    };

    const showMessageBoxEmptyResult = (title, content) => {
        setMessageObject({
            Title: title,
            Content: content,
            IsOpen: true,
        });
        returnValue.current = null;
    };

    const closeMessageBox = () => {
        setMessageObject({
            Title: "",
            Content: "",
            IsOpen: false,
        });
    };

    const handleCloseDialog = (result) => {
        closeMessageBox();
        if(returnValue.current) {
            returnValue.current(result);
        }
        returnValue.current = null;
    };
    

    return (
        <Dialog open={messageObject.IsOpen} TransitionComponent={Transition} maxWidth="sm" fullWidth 
                onClose={() => handleCloseDialog(false)}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
        >
            <DialogTitle>
                {messageObject.Title}
            </DialogTitle>
            <Box position="absolute" top={0} right={0}>
                <IconButton onClick={() => handleCloseDialog(false)}>
                    <Close />
                </IconButton>
            </Box>
            <DialogContent>
                <Typography>
                    {messageObject.Content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleCloseDialog(false)} startIcon={<Cancel />} color="primary" variant="contained">
                    {t('button.cancel')}
                </Button>
                <Button onClick={() => handleCloseDialog(true)} startIcon={<CheckCircle />} color="secondary" variant="contained">
                    {t('button.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );

});

export default Dialog4Confirm;